import { Button, Col, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation';
import '../style.css'
import DynamicForm from '../../../../components/FormElements/DynamicForm';
import { FaEnvelope, FaUserTie } from 'react-icons/fa6';
import { MdOutlineContactPhone } from 'react-icons/md';
import LocationPicker from '../../../../components/LocationPicker';
import { ApiCaller, Colors } from '../../../../config';
import { autoGetLocationFormSchema, manualGetLocationFormSchema } from './schema.js'
import { useMutation } from 'react-query';
import { setError, setMessage } from '../../../../store/common/generalSlice/index.js';
import { BannerImage } from './bannerImage.js';
import { ManualAddressForm } from './manualAddress.js';
import FallbackImg from '../../../../assets/images/fallbackImg.png';
import { FaCamera } from "react-icons/fa6"
import { fetchProfileData } from '../../../../store/common/settingSlice/index.js';

let personalData = {
    name: '',
    type: ''
}

const EditProfile = () => {
    const { loggedInUser } = useSelector(state => state?.auth);
    const [manualLocation, setManualLocation] = useState(false);
    const [profileEditData, setProfileEditData] = useState({});
    const [isError, setIsError] = useState({
        image: false,
        banner: false
    });

    const [coordinates, setCoordinates] = useState({
        latitude: '',
        longitude: ''
    })

    const dispatch = useDispatch()

    const { profileData } = useSelector(state => state?.setting);

    const manualLocationHandler = (values) => {
        if (values?.name == "manualLocation") {
            setManualLocation(values?.value)
        }
    }

    const [manualLocationForm, setManualLocationForm] = useState([
        {
            name: 'addressLine1',
            type: 'text',
            label: { value: 'Address Line 1', style: '', classes: '' },
            placeholder: '4058 Little York Rd.',
            width: { md: 12, sm: 12, xs: 24 },
            component: null,
            classes: 'icon-primary',
            icon: null
        },
        {
            name: 'addressLine2',
            type: 'text',
            label: { value: 'Address Line 2(Optional)', style: '', classes: '' },
            placeholder: '4058 Little',
            width: { md: 12, sm: 12, xs: 24 },
            component: null,
            classes: 'icon-primary',
            icon: null
        },
        {
            name: 'town',
            type: 'text',
            label: { value: 'Town', style: '', classes: '' },
            placeholder: 'York Rd.',
            width: { md: 12, sm: 12, xs: 24 },
            component: null,
            classes: 'icon-primary',
            icon: null
        },
        {
            name: 'postalCode',
            type: 'text',
            label: { value: 'Postal Code', style: '', classes: '' },
            placeholder: 'YAK-9876',
            width: { md: 12, sm: 12, xs: 24 },
            component: null,
            classes: 'icon-primary',
            icon: null
        },
    ]);


    const [form, setForm] = useState({
        name: 'spSignupForm',
        formFields: [
            {
                name: 'image',
                type: 'custom',
                label: { value: '', style: '', classes: '' },
                width: { md: 24, sm: 24, xs: 24 },
                component: <CustomHeader isError={(value) => setIsError((prev) => ({ ...prev, image: value }))} />,
            },
            {
                name: 'fullName',
                type: 'text',
                label: { value: 'Full Name', style: '', classes: '' },
                placeholder: 'Mark Smith',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: 'icon-primary',
                icon: <FaUserTie />
            },
            {
                name: 'email',
                type: 'email',
                label: { value: 'Email Address', style: '', classes: '' },
                placeholder: 'marksmith@gmail.com',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: 'icon-primary',
                icon: <FaEnvelope />,
                readOnly: true
            },
            {
                name: 'phoneNo',
                type: 'text',
                label: { value: 'Phone Number', style: '', classes: '' },
                placeholder: 'Enter Phone Number',
                width: { md: 12, sm: 12, xs: 24 },
                component: null,
                classes: 'icon-primary',
                icon: <MdOutlineContactPhone />
            },
            {
                name: 'address',
                type: 'custom',
                label: { value: 'Location', style: '', classes: '' },
                placeholder: '4058 Little York Rd, Houston',
                width: { md: 12, sm: 12, xs: 24 },
                component: <LocationPicker />,
                classes: 'icon-primary mb-0',
                icon: <MdOutlineContactPhone />
            },
            {
                name: 'manualLocation',
                type: 'custom',
                label: { value: '', style: '', classes: 'checkbox-label' },
                placeholder: '',
                width: { md: 24, sm: 24, xs: 24 },
                component: <ManualAddressForm onCheckChange={manualLocationHandler} />,
                classes: 'icon-primary',
                icon: null
            },
        ],
    })

    useEffect(() => {
        dispatch(fetchProfileData())
    }, [])

    useEffect(() => {
        if (manualLocation) {
            let index = 6;
            let result = [
                ...form?.formFields?.slice(0, index),
                ...manualLocationForm,
                ...form?.formFields?.slice(index)
            ]
            setForm({ ...form, formFields: result, formValidation: manualGetLocationFormSchema })
        }
        else {
            const filtered = form.formFields.filter(e => !manualLocationForm.map(item => item.name).includes(e.name))
            setForm({ ...form, formFields: filtered, formValidation: autoGetLocationFormSchema })
        }
    }, [manualLocation])


    useEffect(() => {
        if (coordinates || (loggedInUser?.type !== "Service User")) {
            setForm(prevForm => {
                let updatedFormFields = [...prevForm.formFields];
                // Update LocationPicker's coordinates
                if (coordinates) {
                    updatedFormFields = updatedFormFields.map(field => {
                        if (field.name === 'address' && field.component.type === LocationPicker) {
                            return {
                                ...field,
                                component: React.cloneElement(field.component, { coordinates })
                            };
                        }
                        return field;
                    });
                }
                // Add banner for non-Service Users

                // condition if only we have to show cover photo option to SP not SU:
                // loggedInUser?.type !== "Service User" && 
                if (prevForm?.formFields[0]?.name !== 'banner') {
                    const coverPhotoObject = {
                        name: 'banner',
                        type: 'custom',
                        label: { value: '', style: '', classes: '' },
                        width: { md: 24, sm: 24, xs: 24 },
                        component: <BannerImage isError={(value) => setIsError((prev) => ({ ...prev, banner: value }))} />,
                    };

                    updatedFormFields = [coverPhotoObject, ...updatedFormFields];
                }

                return { ...prevForm, formFields: updatedFormFields };
            });
        }
    }, [coordinates, loggedInUser]);


    useEffect(() => {
        if (profileData) {
            let data = {
                image: profileData?.imageUrl,
                banner: profileData?.bannerUrl,
                fullName: profileData?.fullName,
                email: profileData?.email,
                phoneNo: profileData?.phoneNo,
                address: profileData?.address,
                city: profileData?.city,
                country: profileData?.country,
                postalCode: profileData?.addressDetail?.postalCode ? profileData?.addressDetail?.postalCode : '',
                town: profileData?.addressDetail?.town ? profileData?.addressDetail?.town : '',
                addressLine1: profileData?.addressDetail?.addressLine1,
                addressLine2: profileData?.addressDetail?.addressLine2
            };
            setProfileEditData(data)

            setCoordinates({
                latitude: Number(profileData?.latitude),
                longitude: Number(profileData?.longitude)
            })

            personalData = {
                name: profileData?.fullName,
                type: profileData?.type
            }

        }

    }, [profileData])

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const profileMutation = useMutation(async (payload) => {
        const formData = new FormData();
        for (const key in payload) {
            formData.append(key, payload[key]);
        }
        // Debugging: check formData entries
        // for (const pair of formData.entries()) {
        //     console.log("formData values", pair[0] + ':', pair[1]);
        // }
        let res = await ApiCaller.put('/user/profile', formData);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                dispatch(fetchProfileData())
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const handleSubmit = (data) => {
        if (isError?.image || isError?.banner) {
            return
        }

        const {
            address: location,
            manualLocation,
            city,
            country,
            postalCode,
            town,
            address1,
            address2,
            ...restData
        } = data;

        let payload = {};

        if (typeof location == 'object') {
            const { lat, lng, address, postalCode, town, city, country } = location;
            payload = {
                address: address,
                latitude: lat,
                longitude: lng,
                postalCode: postalCode ? postalCode : 'Not available',
                town: town ? town : 'Not available',
                city: city ? city : 'Not available',
                country: country ? country : 'Not available',
                addressLine1: address1 ? address1 : 'Not available',
                addressLine2: address2 ? address2 : 'Not available',
                ...restData
            }
        }
        else {
            const { latitude, longitude } = coordinates;
            payload = {
                address: location,
                latitude: latitude,
                longitude: longitude,
                postalCode: postalCode ? postalCode : 'Not available',
                town: town ? town : 'Not available',
                city: city ? city : 'Not available',
                country: country ? country : 'Not available',
                addressLine1: address1 ? address1 : 'Not available',
                addressLine2: address2 ? address2 : 'Not available',
                ...restData
            }
        }
        console.log(payload)
        profileMutation.mutate(payload)
    }

    return (
        <Row>
            <TitleWithBackNavigation title={'Edit Profile'} link={'/settings'} />
            <Row className='w-full my-3 bg-white rounded-md custom--boxShadow py-4 px-2'>
                <Row className='max-w-[800px] w-full rounded-md mx-auto p-3'>
                    <DynamicForm
                        form={form}
                        onSubmit={handleSubmit}
                        editData={profileEditData}
                    />
                    <Col span={24} className="flex items-center justify-center">
                        <Button
                            onClick={submitForm}
                            loading={profileMutation?.isLoading}
                            className='w-36 h-10 mt-3 rounded-md outline-none border-none'
                            style={{ background: Colors.AppYellow, color: 'white' }}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Row>
        </Row>
    )
}

export default EditProfile



// not seperating its file as we are using one const object named as personalData to show name and type
// now actually this component is getting passed into to form json due to which on update of a state as well
// it is not setting the values for different file.

export const CustomHeader = (props) => {
    const [previewImage, setPreviewImage] = useState('')
    const [error, setError] = useState('')
    const imageRef = useRef(null)

    const imageHandler = () => {
        imageRef.current.click()
    }

    console.log(props?.personalData)

    const [check, setCheck] = useState(true);

    useEffect(() => {
        if (props?.value && check) {
            setPreviewImage(props?.value)
        }
    }, [props?.value])

    const fileChooseHandler = (e) => {
        let selectedImg = e.target.files[0]
        if (selectedImg && !['image/jpeg', 'image/png'].includes(selectedImg?.type)) {
            setError('Format is invalid')
            props?.isError(true)
            return
        }
        else {
            setCheck(false)
            if (selectedImg) {
                const previewUrl = URL.createObjectURL(selectedImg)
                setPreviewImage(previewUrl)
                props?.onChange(selectedImg)
                setError('')
                props?.isError(false)
            }
        }
    }

    return (
        <Row className='w-full'>
            <Col span={24} className='flex items-center justify-center flex-col gap-2'>

                <div className='rounded-full border border-gray-300 w-32 h-32 relative cursor-pointer' onClick={imageHandler}>
                    <input type='file' ref={imageRef} onChange={fileChooseHandler} hidden />
                    <img className='w-full h-full object-cover object-center rounded-full' src={previewImage || FallbackImg} />
                    <div className='absolute bottom-1 right-0 p-3 rounded-full bg-gray-200'>
                        <FaCamera color={Colors.AppYellow} size={17} />
                    </div>
                </div>
                {error && <p className="text-start text-red-400 text-lg">{error}</p>}
                <div className='flex flex-col items-center'>
                    <h2 className='text-lg font-medium'>{personalData?.name ? personalData?.name : '-'}</h2>
                    <p className='text-sm text-gray-500'>{personalData?.type ? personalData?.type : '-'}</p>
                </div>

            </Col>
        </Row>
    )
}
